import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { MatSidenav, MatSidenavContainer } from '@angular/material/sidenav';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '../../services';
import { HeaderComponent } from '../header/header.component';
import { SidenavComponent } from '../sidenav/sidenav.component';

@Component({
    selector: 'app-content',
    templateUrl: './content.component.html',
    styleUrls: ['./content.component.scss'],
    standalone: true,
    host: { class: 'app-content' },
    imports: [
        MatSidenav,
        MatSidenavContainer,
        TranslateModule,
        HeaderComponent,
        SidenavComponent,
        NgTemplateOutlet,
        CommonModule,
        MatProgressSpinner
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentComponent {
    readonly authService = inject(AuthService);
    readonly isFooterVisible = input<boolean>(true);
    readonly isFullScreen = input<boolean>(false);

    opened: boolean = false;
}
